import { actions } from './corps/actions'
import { getters } from './corps/getters'
import { state } from './corps/state'
import { mutations } from './corps/mutations'

export default {
    namespaced: true,
    getters,
    state,
    mutations,
    actions
}
